<template>
  <div class="gs-app gm-email-template-categories-catalog">
    <!-- Loader -->
    <portal to="loaderTarget">
      <div class="absolute bg-grey-100 bg-opacity-50 h-full left-0 top-0 w-full z-99" v-if="isLoading">
        <gd-loader :label="$t('frontend_loading')"/>
      </div>
    </portal>

    <div class="flex mb-4 mx-4 gm-email-template-categories-catalog__shell">
      <div class="w-full gm-email-template-categories-catalog__workspace">
        <navigation-tabs
          class="gm-nav-sequences-tabs absolute"
          :nav_tabs="navTabs"
        ></navigation-tabs>
        <server-table
          class="text-center groovemail-email-template-cat-table gs-refresh-controls"
          ref="serverTable"
          url="/user-template-folders"
          tableRef="emailTemplateCatTable"
          tableTitle="frontend_groovemail_email_template_categories_header"
          addNewBtnText="frontend_groovemail_adminsetting_create_new_category"
          :slotData="emailTemplateCategorySlotData"
          :tableColumns="email_templates_cat_table_columns"
          :tableOptions="email_templates_cat_table_options"
          @addNewData="createNewCategory"
          @loaded="hideLoader()"
          @loading="showLoader()"
        >
        </server-table>
      </div>
    </div>

    <gs-named-modal class="gs-refresh-controls"
      id="template-folder-create-modal"
      name="template-folder-create-modal"
      :title="
        categoryId
          ? $t('frontend_groovemail_mail_category_upadate_cat')
          : currentCategory
          ? $t('frontend_groovemail_clone_category')
          : $t('frontend_new_category')
      "
    >
      <VuePerfectScrollbar>
        <div class="w-full p-6" style="max-height: calc(100vh - 115px)">
          <template-folder-create
            :from="'my-template'"
            :catId="categoryId"
            :category="currentCategory"
            @showLoader="showLoader"
            @hideLoader="hideLoader"
            @folderCreatedForTemplates="closeCreateFolderModal"
            @folderUpdatedForTemplates="closeCreateFolderModal"
            @closeFolderCreateModal="closeCreateFolderModal"
          >
          </template-folder-create>
        </div>
      </VuePerfectScrollbar>
    </gs-named-modal>

    <gs-named-modal class="gs-refresh-controls"
      id="email-template-listing-modal"
      name="email-template-listing-modal"
      width="100%"
      :title="
        this.emailsTemplatesUrl.includes('user')
          ? $t('frontend_sites_my_templates')
          : $t('frontend_groovemail_saved_past_emails_page_header')
      "
    >
      <VuePerfectScrollbar>
        <server-table
          class="text-center groovemail-email-templates-table"
          ref="serverTable"
          :url="emailsTemplatesUrl"
          tableRef="emailsTemplatesTable"
          :tableColumns="emailsTemplatesColumns"
          :tableOptions="emailsTemplatesOptions"
          @loaded="hideLoader()"
          @loading="showLoader()"
        >
        </server-table>
      </VuePerfectScrollbar>
    </gs-named-modal>


    <!-- Confirmation Modal -->
    <confirm-modal
      :ref="`confirmation-delete-cat`"
      :name="`confirmation-delete-cat`"
      :buttonText="$t('frontend_delete')"
      :cancelText="$t('frontend_cancel')"
      :confirmMessage="this.$t('frontend_bouses_delete_bonus_title')"
      :messageContent="this.$t('frontend_groovemail_delete_email_template_broadcast_category')"
      @confirm="deleteCategory"
    />
  </div>
</template>

<script>
import axios from 'axios';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import ServerTable from '@groovepages/gd-ui-kit/components/tables/ServerTable.vue';
import themeConfig from '@/theme/themeConfig.js';

import TemplateFolderCreate from '@/components/befree-email-builder/template-folder-create.vue';
import NavigationTabs from '@/components/navigation-tabs.vue';
import showAlert from '@/components/sweet-alert-popup.js';

export default {
  name: 'EmailTemplateCategories',
  middleware: 'auth',
  metaInfo() {
    return {
      title: this.$t('frontend_groovemail_email_template_categories_header'),
    };
  },
  data() {
    return {
      categoryId: null,
      currentCategory: '',
      tableKey: 1,
      emailsTemplatesTableKey: 2,
      navTabs: [
        {
          tabName: 'frontend_groovemail_email_template_categories_header',
          tabRoute: 'EmailTemplateCategories',
        },
        {
          tabName: 'frontend_groovemail_broadcast_categories_header',
          tabRoute: 'BroadcastCategories',
        },
      ],
      fullPageLoader: true,
      isLoading: false,
      loaderColor: themeConfig.appPrimaryColor,
      email_templates_cat_table_columns: [
        'name',
        'my_templates_count',
        'saved_emails_count',
        'created_at',
        'actions',
      ],
      email_templates_cat_table_options: {
        perPage: 10,
        debounce: 1000,
        alwaysShowPerPageSelect: true,
        perPageValues: [10, 25, 50, 100],
        pagination: { chunk: 5 },
        sortIcon: {
          base: 'fa',
          is: 'fa-sort',
          up: 'fa-sort-asc',
          down: 'fa-sort-desc',
        },
        texts: {
          filterPlaceholder: this.$t('frontend_groovemail_tables_search_query'),
        },
        filterable: ['name'],
        sortable: ['name', 'created_at'],
        headings: {
          name: () => this.$t('frontend_groovemail_adminsetting_name'),
          my_templates_count: () => this.$t('frontend_sites_my_templates'),
          saved_emails_count: () => this.$t('frontend_groovemail_saved_past_emails_page_header'),
          created_at: () => this.$t('frontend_groovemail_created_at'),
          actions: () => this.$t('frontend_groovemail_mail_lead_actions'),
        },
        requestFunction(data) {
          const self = this;
          if (!(data && data.orderBy)) {
            data.orderBy = 'created_at';
            data.ascending = 0;
          }
          return axios
            .get(self.url, {
              params: data,
            })
            .catch((e) => {
              self.dispatch('error', e);
              self.hideLoader();
            });
        },
        responseAdapter({ data }) {
          return {
            data: data.data ? data.data : [],
            count: data.total,
          };
        },
      },
      emailsTemplatesUrl: '',
      emailsTemplatesColumns: ['id', 'name'],
      emailsTemplatesOptions: {
        perPage: 5,
        debounce: 1000,
        alwaysShowPerPageSelect: true,
        perPageValues: [5],
        pagination: { chunk: 5 },
        sortIcon: {
          base: 'fa',
          is: 'fa-sort',
          up: 'fa-sort-asc',
          down: 'fa-sort-desc',
        },
        texts: {
          filterPlaceholder: this.$t('frontend_groovemail_tables_search_query'),
        },
        filterable: [],
        sortable: [],
        headings: {
          name: () => this.$t('frontend_groovemail_adminsetting_name'),
        },
        requestFunction(data) {
          const paramsData = { ...data };
          const apiUrl = this.url.substr(0, this.url.lastIndexOf('/'));
          const catId = this.url.substr(
            this.url.lastIndexOf('/') + 1,
            this.url.length + 1
          );
          paramsData.category_ids = [catId];
          return axios
            .get(apiUrl, {
              params: paramsData,
            })
            .catch((e) => {
              this.dispatch('error', e);
            });
        },
        responseAdapter({ data }) {
          return {
            data: data.data,
            count: data.total,
          };
        },
      },
    };
  },

  computed: {
    months() {
      return [
        this.$t('frontend_groovemail_month_jan_short'),
        this.$t('frontend_groovemail_month_feb_short'),
        this.$t('frontend_groovemail_month_mar_short'),
        this.$t('frontend_groovemail_month_apr_short'),
        this.$t('frontend_groovemail_month_may_short'),
        this.$t('frontend_groovemail_month_jun_short'),
        this.$t('frontend_groovemail_month_jul_short'),
        this.$t('frontend_groovemail_month_aug_short'),
        this.$t('frontend_groovemail_month_sep_short'),
        this.$t('frontend_groovemail_month_oct_short'),
        this.$t('frontend_groovemail_month_nov_short'),
        this.$t('frontend_groovemail_month_dec_short'),
      ];
    },
    emailTemplateCategorySlotData() {
      return [
        {
          slotName: 'category_name',
          slotType: 'computed',
          classes: () => '',
          value: (props) => {
            return props.row.category_name
              ? props.row.category_name
              : this.$t('frontend_groovemail_not_available');
          },
        },
        {
          slotName: 'my_templates_count',
          slotType: 'clickable',
          classes: () => '',
          callback: (props) => this.fetchEmailTemplates(props.row, 1),
          defaultValue: 0,
        },
        {
          slotName: 'saved_emails_count',
          slotType: 'clickable',
          classes: () =>  '',
          callback: (props) => this.fetchEmailTemplates(props.row, 2),
          defaultValue: 0,
        },
        {
          slotName: 'created_at',
          slotType: 'computed',
          classes: () => '',
          value: (props) => {
            return props.row.created_at
              ? `${new Date(props.row.created_at).getDate()} ${
                  this.months[new Date(props.row.created_at).getMonth()]
                }, ${new Date(props.row.created_at).getFullYear()}`
              : this.$t('frontend_groovemail_not_available');
          },
        },
        {
          slotName: 'actions',
          slotType: 'actions',
          conditions: (props) => {
            if (props.row.id !== '0') return true;

            return false;
          },
          classes: () => {
            return {
              outerDiv: '',
              dropdown: '',
              outerSpan: '',
            };
          },
          actionList: [
            {
              id: 0,
              name: () => this.$t('frontend_edit'),
              conditions: () => true,
              callback: (props) => this.updateCategory(props.row),
            },
            {
              id: 1,
              name: () => this.$t('frontend_clone'),
              conditions: () => true,
              callback: (props) => this.cloneCategory(props.row),
            },
            {
              id: 2,
              name: () => this.$t('frontend_delete'),
              conditions: () => true,
              callback: (props) => this.deleteCategoryModal(props.row),
            },
          ],
        },
      ];
    },
  },

  components: {
    NavigationTabs,
    VuePerfectScrollbar,
    TemplateFolderCreate,
    ServerTable,
  },

  methods: {
    // show loader
    showLoader() {
      if (!this.isLoading) {
        this.isLoading = true;
      }
    },

    // hide loader
    hideLoader() {
      if (this.isLoading) {
        this.isLoading = false;
      }
    },

    // error message for the request field
    async requestErrorAlert(error) {
      // hide the loader
      this.hideLoader();
      
      await showAlert({
        iconType: 'alert-error',
        html : `
          <style>.swal2-cancel { color: ${themeConfig.appPrimaryColorInvert} !important; }</style>
          <p class="text-sm text-deep-dark mb-3">${error || this.$t('frontend_backend_error') }</p>
        `,
        showCancelButton: false,
        showCloseButton: true,
        confirmButtonColor: themeConfig.appPrimaryColor,
        confirmButtonText: this.$t('frontend_close'),
      });
    },

    createNewCategory() {
      this.categoryId = null;
      this.currentCategory = '';
      this.openFolderModal();
    },

    openFolderModal() {
      this.$root.$emit('modal-open', 'template-folder-create-modal');
    },

    closeFolderModal() {
      this.$root.$emit('modal-close', 'template-folder-create-modal');
    },

    closeCreateFolderModal(folderCreated) {
      this.closeFolderModal();
      if (folderCreated) {
        this.$refs.serverTable.$refs.emailTemplateCatTable.refresh();
      }
    },

    fetchEmailTemplates(category, type) {
      if (type === 1) {
        this.emailsTemplatesUrl = `/user/template/list/${category.id}`;
      } else if (type === 2) {
        this.emailsTemplatesUrl = `/email/template/list/${category.id}`;
      }
      this.$root.$emit('modal-open', 'email-template-listing-modal');
    },

    updateCategory(category) {
      this.categoryId = category.id;
      this.currentCategory = category.name;
      this.openFolderModal();
    },

    cloneCategory(category) {
      this.categoryId = null;
      this.currentCategory = `${category.name} [ ${this.$t(
        'frontend_copy'
      ).toUpperCase()} ]`;
      this.openFolderModal();
    },

    // open delete category modal
    async deleteCategoryModal(category) {
      // set the category id
      this.categoryId = category.id;

      // open the modal
      this.$refs[`confirmation-delete-cat`].open();
    },

    // close delete category modal
    closeDeleteCategoryModal() {
      // reset the category id
      this.categoryId = null;

      // close the modal
      this.$refs[`confirmation-delete-cat`].close();
    },

    // delete category
    async deleteCategory() {
      try {
        this.showLoader();
        await axios.delete(`/template-subcategory/${this.categoryId}`);
        const catData = await axios.get(`/user-template-folders?query=${this.$refs.serverTable.$refs.emailTemplateCatTable.filteredQuery}&limit=${this.email_templates_cat_table_options.perPage}&page=${this.$refs.serverTable.$refs.emailTemplateCatTable.Page}&ascending=0&byColumn=0`
        );
        this.$refs.serverTable.updateData(
          catData?.data?.data,
          catData?.data?.total
        );
        this.hideLoader();
      } catch (error) {
        // show the error alert
        this.requestErrorAlert(error.response?.data?.error);
      }
    },
  },
};
</script>

<style lang="scss">
.groovemail-email-template-cat-table {
  .VueTables--server table {
    th:nth-child(1),
    td:nth-child(1) {
      width: 35% !important;
      word-break: break-word;
    }
    th:nth-child(2),
    td:nth-child(2),
    th:nth-child(3),
    td:nth-child(3),
    th:nth-child(4),
    td:nth-child(4) {
      width: 18% !important;
      word-break: break-word;
    }
  }
}

.groovemail-email-templates-table {
  .VueTables--server {
    padding: 24px;
    .table-responsive {
      background: #ffffff !important;
      .VueTables__table {
        th:last-child span {
          display: block !important;
        }
        border: 1px solid #ccc !important;
      }
    }
    td {
      word-break: break-all;
    }
    .VuePagination {
      margin-bottom: 10px;
    }
    .VueTables__limit-field {
      display: none !important;
    }
  }
  .VueTables--server table {
    th:nth-child(1),
    td:nth-child(1),
    th:nth-child(2),
    td:nth-child(2) {
      width: 50% !important;
      word-break: break-word;
    }
  }
}
</style>

<style scoped>
.gm-email-template-categories-catalog {
  min-height: 100%;
  padding: 28px;
  color: var(--gs-foreground);
  background: var(--gs-background);
}

.gm-email-template-categories-catalog__shell {
  margin: 0;
}

.gm-email-template-categories-catalog__workspace {
  min-width: 0;
  padding: 20px 24px 24px;
  background: var(--gs-surface);
  border: 1px solid var(--gs-border);
  border-radius: var(--gs-radius-lg);
  box-shadow: var(--gs-shadow-sm);
}

.gm-email-template-categories-catalog >>> .VueTables__table,
.gm-email-template-categories-catalog >>> .VueTables__table th,
.gm-email-template-categories-catalog >>> .VueTables__table td {
  border-color: var(--gs-border);
}

@media (max-width: 640px) {
  .gm-email-template-categories-catalog { padding: 18px 12px 32px; }
  .gm-email-template-categories-catalog__workspace { padding: 16px; }
}
</style>
